import React from 'react';
import { translate } from 'react-i18next';
import firebase from '../firebase';
import compose from '../compose';
import user from '../Auth/user';
import { withRouter } from 'react-router-dom';
import MenuItem from 'material-ui/MenuItem';

class StandCreate extends React.Component {
  constructor(props) {
    super(props);
    this.initialState =  {
      stand: ''
    };

    this.state = {
      ...this.initialState
    };
  }
  componentWillReceiveProps = (nextProps) => {
    if (nextProps.stand) {
      this.setState({stand: nextProps.stand});
    }
  }
  handleDuplicate = () => {
    if (!this.state.stand) return;
    var stand = this.state.stand;
    stand.name += ' - copy';
    delete stand.key;
    delete stand.standTag;

    for (var product in stand.products) {
      delete stand.products[product].inventoryChanges;
      delete stand.products[product].totalCount;
    }
    const {firebase, user} = this.props;
    var newStandRef = firebase.database().ref(`shopkeepers/${user.shopkeeperId}/stands/`).push();
    newStandRef.set(stand).then(() => {
      firebase.database().ref(`shopkeepers/${user.shopkeeperId}/standsList/${newStandRef.key}`).set(stand);
      this.props.history.push('/stands');
      this.props.history.replace(`/stands/${newStandRef.key}`);
    });
  }
  render() {
    const {t} = this.props;

    return (
      <MenuItem
        primaryText={t('stand.duplicate')}
        onTouchTap={this.handleDuplicate}/>
    );
  }
}

const enhance = compose(translate(), firebase, user, withRouter);

export default enhance(StandCreate);



// WEBPACK FOOTER //
// ./src/Stand/StandDuplicate.js